export default {
  referring: "referring",
  couponPercentOff: "coupon_percent_off",
  couponAmountOff: "coupon_amount_off",
};
